
import axios from "axios";
import { defineComponent, ref, nextTick } from "vue";
import ModalCom1 from "@/components/ModalCom1.vue";

export default defineComponent({
  props: {
    date: String,
    spa: String,
    conWidth: Number,
    rule2: String,
    week: String,
  },
  components: {
    ModalCom1,
  },
  data() {
    return {
      columns: [
        { prop: "image", label: "照片", show: true, fixed: "left", width: "120px" },
        {
          prop: "name",
          label: "姓名",
          show: false,
          sortable: true,
          fixed: "left",
          width: "90px",
        },
        { prop: "price", label: "台費", show: false, sortable: true, width: "90px" },
        { prop: "height", label: "身高", show: false, sortable: true, width: "90px" },
        { prop: "weight", label: "體重", show: false, sortable: true, width: "90px" },
        { prop: "cup", label: "罩杯", show: false, sortable: true, width: "90px" },
        {
          prop: "work_time",
          label: "可約時段",
          show: false,
          sortable: true,
          width: "150px",
        },
        {
          prop: "info",
          label: " ",
          show: false,
          sortable: true,
          html: true,
          width: "200px",
        },
      ],
      tableItem: [
        {
          spa_id: "",
          id: "",
          image: "",
          name: "",
          price: "",
          height: "",
          weight: "",
          cup: "",
          work_time: "",
          info: "",
        },
      ],
      tempTableItem: [
        {
          spa_id: "",
          id: "",
          image: "",
          name: "",
          price: "",
          height: "",
          weight: "",
          cup: "",
          work_time: "",
          info: "",
          spa_name: "",
          name_his: "",
        },
      ],
      tableHeight: 0,
      work3Data: [
        {
          spa_id: "",
          name: "",
          work_time: "",
        },
      ],
      spaConfig: [{ id: "", name: "" }],
      dataLoading: false,
      commSpa: "",
      commName: "",
    };
  },
  methods: {
    async selectAllWork3() {
      this.dataLoading = true;
      this.tableItem.splice(0);
      this.tempTableItem.splice(0);

      var url = "/php/spa_table.php";
      await axios
        .post(url, {
          action: "selectAllWork3",
          week: this.week,
        })
        .then((res) => {
          this.work3Data = res.data;
        })
        .catch((error) => {
          console.error(error);
        });

      var myMap = new Map();
      var workTimeMap = new Map();

      for (var i = 0; i < this.work3Data.length; i++) {
        var item = this.work3Data[i];
        if (myMap.get(item.spa_id)) {
          myMap.get(item.spa_id).push(item.name);
        } else {
          var arr = [item.name];
          myMap.set(item.spa_id, arr);
        }

        if (!workTimeMap.get(item.spa_id + item.name)) {
          workTimeMap.set(item.spa_id + item.name.toUpperCase(), item.work_time);
        }
      }

      for (var [key, value] of myMap) {
        var name = "";
        value.forEach((element) => {
          var tempName = ",'" + element + "'";
          name += tempName;
        });
        name = name.substring(1);

        await axios
          .post(url, {
            action: "selectSpaDataByName",
            table_name: key,
            name: name,
          })
          .then((res) => {
            for (var i = 0; i < res.data.length; i++) {
              var item = res.data[i];
              item["spa_id"] = key;
              this.tempTableItem.push(item);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }

      for (var j = 0; j < this.tempTableItem.length; j++) {
        var tempItem = this.tempTableItem[j];
        tempItem.image = "https://imgf.gg9453.com/images/spa_daily/" + tempItem.image;
        tempItem.work_time = workTimeMap.get(
          tempItem.spa_id + tempItem.name.toUpperCase()
        );

        var findSpaName = this.spaConfig.find((e) => e.id === tempItem.spa_id);
        if (findSpaName) {
          tempItem.spa_name = findSpaName.name;
        }

        if (tempItem.name_his) {
          tempItem.info = tempItem.info + "<br>" + tempItem.name_his;
        }
        tempItem.info = "";
      }

      this.tableItem = JSON.parse(JSON.stringify(this.tempTableItem));
      this.dataLoading = false;

      this.$nextTick(function () {
        const aa: any = this.$refs.elTable;
        aa.clearSort();
        aa.sort("work_time", "ascending");
      });
    },
    selectAll() {
      axios
        .post("/php/spa_config.php", {
          action: "selectAll",
        })
        .then((res) => {
          this.spaConfig = res.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    doButton(spa1, name1) {
      this.commSpa = spa1;
      this.commName = name1;
      console.log("doButton=" + this.commSpa + " " + this.commName);
    },
  },
  created() {
    this.selectAll();
    this.tableHeight = window.innerHeight - 220;
    if (this.tableHeight < 500) {
      this.tableHeight = 500;
    }
    if (window.innerWidth < 600) {
      this.columns = [
        { prop: "image", label: "照片", show: true, fixed: "left", width: "65px" },
        {
          prop: "name",
          label: "姓名",
          show: false,
          sortable: true,
          fixed: "left",
          width: "85px",
        },
        {
          prop: "work_time",
          label: "時段",
          show: false,
          sortable: true,
          width: "80px",
        },
        {
          prop: "spa_name",
          label: "店家",
          show: false,
          sortable: true,
          width: "80px",
        },
        { prop: "price", label: "台費", show: false, sortable: true, width: "80px" },
        { prop: "height", label: "身高", show: false, sortable: true, width: "80px" },
        { prop: "weight", label: "體重", show: false, sortable: true, width: "80px" },
        { prop: "cup", label: "罩杯", show: false, sortable: true, width: "80px" },
        {
          prop: "info",
          label: " ",
          show: false,
          sortable: true,
          html: true,
          width: "300px",
        },
      ];
    } else {
      this.columns = [
        { prop: "image", label: "照片", show: true, fixed: "left", width: "200px" },
        {
          prop: "name",
          label: "姓名",
          show: false,
          sortable: true,
          fixed: "left",
          width: "100px",
        },
        {
          prop: "work_time",
          label: "時段",
          show: false,
          sortable: true,
          width: "130px",
        },
        {
          prop: "spa_name",
          label: "店家",
          show: false,
          sortable: true,
          width: "90px",
        },
        { prop: "price", label: "台費", show: false, sortable: true, width: "90px" },
        { prop: "height", label: "身高", show: false, sortable: true, width: "90px" },
        { prop: "weight", label: "體重", show: false, sortable: true, width: "90px" },
        { prop: "cup", label: "罩杯", show: false, sortable: true, width: "90px" },
        {
          prop: "info",
          label: " ",
          show: false,
          sortable: true,
          html: true,
          width: "460px",
        },
      ];
    }
  },
  mounted() {
    //this.selectAllWork3();
    console.log(this.week);
  },
  watch: {
    week: function (val, oldVal) {
      this.selectAllWork3();
    },
  },
});
